import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // 에디터 전역 컨텍스트 설정
    window.currentProjectId = this.element.dataset.projectId
    window.currentUserId = this.element.dataset.userId
    window.uiUxDesignPlanningOrigin = {
      present: this.element.dataset.planningOriginPresent === 'true',
      id: this.element.dataset.planningOriginId ? Number(this.element.dataset.planningOriginId) : null,
      name: this.element.dataset.planningOriginName || '',
      path: this.element.dataset.planningOriginPath || ''
    }

    // UI/UX 디자인은 category를 'design'으로 고정
    window.selectedCategory = 'design'

    // 이미지 생성 모델은 UI/UX 전용 저장 키를 우선 복원
    const savedImageModel = localStorage.getItem('selectedUiUxImageModel') || window.selectedImageModel || ''
    window.selectedImageModel = savedImageModel
    window.selectedUiUxImageModel = savedImageModel

    // 갓 생성된 빈 프로젝트는 항상 UI 탭으로 시작 (localStorage 기록 무시)
    const isFreshProject = this.element.dataset.projectFresh === 'true'
    if (isFreshProject) {
      localStorage.setItem('selectedChatMode', 'ui_only')
    }

    const savedMode = localStorage.getItem('selectedChatMode')
    const savedAiMode = localStorage.getItem('selectedAiMode')

    if (savedMode) {
      window.selectedMode = savedMode
      const radio = document.querySelector(`input[name="chat-mode"][value="${savedMode}"]`)
      if (radio) radio.checked = true
    }

    if (savedAiMode) {
      window.selectedAiMode = savedAiMode
      const label = document.getElementById('ai-mode-label')
      if (label) label.textContent = savedAiMode.toUpperCase()
    }

    // 프로젝트명 입력 이벤트
    this._setupProjectNameInput()

    // 에디터 모듈 로드 (한 번만)
    if (!window.__uiUxDesignLoaded) {
      window.__uiUxDesignLoaded = true
      this._loadEditorModules()
    }
  }

  disconnect() {
    window.__uiUxDesignLoaded = false
  }

  _setupProjectNameInput() {
    const input = document.getElementById('project-name-input')
    if (!input) return

    input.addEventListener('blur', async () => {
      const newName = input.value.trim()
      if (!newName || !window.currentProjectId) return

      try {
        if (window.ProjectManager && typeof window.ProjectManager.updateProjectName === 'function') {
          await window.ProjectManager.updateProjectName(window.currentProjectId, newName)
          document.title = `${newName} - UI/UX 디자인`
        }
      } catch (e) {
        console.error('[UiUxDesignEditor] 프로젝트명 업데이트 오류:', e)
      }
    })

    input.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        e.preventDefault()
        this.blur()
      }
      if ((e.metaKey || e.ctrlKey) && e.key === 'a') {
        e.preventDefault()
        this.select()
      }
    })
  }

  async _loadEditorModules() {
    // application.js 번들이 esbuild 최소화 과정에서 Marked.js 클래스를 var $ = class {} 로 이름 붙여
    // window.$를 덮어쓴다. jQuery는 window.jQuery로도 등록되므로 import 직전에 복구.
    if (typeof window.jQuery !== 'undefined') {
      window.$ = window.jQuery
    }
    try {
      // index.js가 진입점: ChatManager, ProjectManager, AI클라이언트 등 모두 import 후 UIController 인스턴스 생성
      await import('/js/ui-ux-design/index.js?v=' + Date.now())
    } catch (e) {
      console.error('[UiUxDesignEditor] 에디터 모듈 로드 실패:', e)
    }
  }
}
